import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class TimelineToggleWeeklyViewCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.TIMELINE_TOGGLE_WEEKLY_VIEW;

    public tags = ['ui', 'timeline', 'view'];

    constructor() {
        super('timeline', 'system', undefined);
    }
}